<template>
  <div style="height: calc(100vh - 60px); background: #F2F2F6;overflow:auto">
         <el-breadcrumb  separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }"> {{ $t("base.index") }}</el-breadcrumb-item>
          <el-breadcrumb-item> {{ $t("index.customer") }}</el-breadcrumb-item>
          <el-breadcrumb-item> {{ $t("index.customerList") }}</el-breadcrumb-item>
        </el-breadcrumb>
   <el-form size="mini" label-width="130px" :model="where" class="demo-form-inline">
  <el-row>
   
    <el-col :span="6">
   <el-form-item :label="$t('base.mobile')">
    <el-input v-model="where.mobile"></el-input>
  </el-form-item>
    </el-col>
       <el-col :span="6">
   <el-form-item label="储值会员">
     <el-checkbox v-model="where.money"></el-checkbox>
  </el-form-item>
    </el-col>
     <el-col :span="6">
   <el-form-item label="订阅会员">
     <el-checkbox v-model="where.isvip" ></el-checkbox>
  </el-form-item>
    </el-col>
       <el-col :span="6" style="text-align:right">
        <el-button size="mini" type="primary" @click="searchCustomer()">{{ $t("base.search") }}</el-button>
        <el-divider direction="vertical"></el-divider>
        <el-button  :title="$t('base.new')" style="background:linear-gradient(to bottom,rgb(90, 157, 171),#0093a8);color:#ffffff" size="small" icon="el-icon-plus" @click="CreateCustomer()"></el-button>
      </el-col>
  </el-row>
   <el-divider></el-divider>
</el-form>
        <el-table
          :data="tabledata"
          ref="table"
          height="calc(100% - 190px)"
          stripe
          border
          style="margin:0 30px;width: calc(100% - 60px);border-radius: 0.625rem;font-size:12px"
           :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'line-height': '20px', padding: '8px', 'text-align': 'center' }"
        >
          <el-table-column
            type="index"
            label=""
            :index="indexMethod"
          ></el-table-column>
          <el-table-column prop="name" :label="$t('customer.avatar')">
            <template slot-scope="scope">
                <el-avatar size="small" key="contain" :src="scope.row.avatar">{{scope.row.nickname}}</el-avatar>
            </template>
             </el-table-column>
             <el-table-column prop="nickname" label="昵称">
             </el-table-column>
          <el-table-column prop="mobile" :label="$t('base.mobile')"> </el-table-column>
          <el-table-column  label="会员类型">
            <template slot-scope="scope">
                <el-tag type="success" size="small" v-if="scope.row.money>0">储值会员</el-tag>
                 <el-tag type="info" size="small" v-else>普通会员</el-tag>
                <el-tag v-if="new Date(scope.row.vip_expire_time)>new Date()" size="small">订阅会员</el-tag>
            </template>
           </el-table-column>
          <el-table-column prop="money" label="余额" width="100">
            <template slot-scope="scope">
            {{ scope.row.money.toFixed(2) }}
              <el-button class="el-icon-edit" size="mini" type="text" @click="dialogTableVisible=true"></el-button>
            </template>
           </el-table-column>
             <el-table-column prop="discount" label="折扣" width="100">
            <template slot-scope="scope">
            {{ scope.row.discount*100 }}%
            </template>
           </el-table-column>
              <el-table-column prop="vip_expire_time" label="订阅到期时间">
           </el-table-column>
          <el-table-column :label="$t('base.opt')" column-key="opt" >
            <template  slot-scope="scope" >
            <el-button
                size="mini"
                type="text"
                @click="$router.push({ name: 'EditCustomer', params: { innerid: scope.row.innerid } })"
                >编辑</el-button>
              <el-button
                size="mini"
                type="text"
                @click="handleDelete(scope.row)"
                >{{$t("base.del")}}</el-button>
            </template>
          </el-table-column>
        </el-table>
    <el-row style="height:40px">
        <el-pagination
          background
          :page-sizes="[10, 15, 30, 50, 100]"
          :current-page="pageset.index"
          :page-size="pageset.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="totalsize"
          style="float: right; margin-top: 0.625rem;margin-bottom:10px"
        >
        </el-pagination>
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'UserList',
  data () {
    return {
    user:{},
      dialogTableVisible:false,
      text:[],
      tabledata: [],
      pageset: {
        size: 15,
        index: 1
      },
      totalsize: 0,
      where: {
        mobile: '',
        money:false,
        isvip:false
      }
    }
  },
  mounted: function () {
    let customer = window.localStorage.getItem('customer')
    if (customer) {
      this.user = JSON.parse(customer)
      this.searchCustomer()
    } else {
      this.$message({
        message:this.$t("base.noSession"),
        type: 'warning'
      })
      this.$router.push({ name: 'Login' })
    }
  },
  methods: {
    searchCustomer () {
      var self = this
        Vue.axios
          .post('/customer/list', {
            where: this.where,
            pageset: this.pageset
          })
          .then((res) => {
            if (res.data.errcode == 0) {
              self.tabledata = res.data.msgbody
            } else {
              this.$message({
                showClose: true,
                message: res.data.errmsg || this.$t("base.systemError"),
                type: 'error'
              })
            }
          })
        Vue.axios
          .post('/customer/list/count', {
            where: this.where
          })
          .then((res) => {
            if (res.data.errcode == 0) {
              self.totalsize = res.data.msgbody
            } else {
              this.$message({
                showClose: true,
                message: res.data.errmsg || this.$t("base.systemError"),
                type: 'error'
              })
            }
          })
      
    },
    indexMethod (index) {
      return (this.pageset.index - 1) * this.pageset.size + index + 1
    },
    handleSizeChange (val) {
      this.pageset.size = val
      this.searchCustomer()
    },
    handleCurrentChange (val) {
      this.pageset.index = val
      this.searchCustomer()
    },
    CreateCustomer  () {
      let self = this
      this.$prompt('新增会员', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: '',
        inputPattern: /^1[0-9]{10}$/,
        inputErrorMessage: '请输入正确的手机号码'
      }).then(({ value }) => {
        Vue.axios
          .post('/customer/create', { mobile: value})
          .then((res) => {
            if (res.data.errcode == 0) {
              self.$message({
                type: 'success',
                message: '保存成功'
              })
              self.searchCustomer()
            } else {
              self.$message({
                showClose: true,
                message:
                    res.data.errmsg || this.$t('base.systemError'),
                type: 'error'
              })
            }
          })
      }).catch(() => {

      })
    },
    handleDelete (row) {
      this.$confirm(
        this.$t('setup.confirmDeleteStaff') + row.mobile + '？',
       this.$t("base.info"),
        {
          confirmButtonText: this.$t("base.confirm"),
          cancelButtonText: this.$t("base.cancel"),
          type: 'warning'
        }
      )
        .then(() => {
          var self = this
          Vue.axios
            .post('/customer/del', {
              innerid: row.innerid
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  type: 'success',
                  message: self.$t('base.delSuccess')
                })
                self.searchCustomer()
              } else {
                self.$message({
                  showClose: true,
                  message:
                    res.data.errmsg || this.$t("base.systemError"),
                  type: 'error'
                })
              }
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Customer/Index.vue